import { type TypedDocumentNode, gql } from '@apollo/client';
import { Navigate, Outlet, generatePath } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { NewPageHeader } from '@sorare/core/src/components/navigation/NewPageHeader';
import {
  FOOTBALL_PLAY_PRO_FIXTURE,
  FOOTBALL_PLAY_PRO_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK,
} from '@sorare/core/src/constants/__generated__/routes';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';
import { navLabels } from '@sorare/core/src/lib/glossary';

import type {
  FixtureCompetitionTrckGrpLayoutQuery,
  FixtureCompetitionTrckGrpLayoutQueryVariables,
} from './__generated__/layout.graphql';
import { LayoutParams } from './__generated__/routeParams';

const FIXTURE_COMPETITION_TRCKGRP_LAYOUT_QUERY = gql`
  query FixtureCompetitionTrckGrpLayoutQuery(
    $competition: String!
    $trckGrp: String!
  ) {
    so5 {
      so5League(slug: $competition) {
        slug
        so5LeagueTrackGroup(slug: $trckGrp) {
          slug
          so5LeagueTracks {
            slug
          }
        }
      }
    }
  }
` as TypedDocumentNode<
  FixtureCompetitionTrckGrpLayoutQuery,
  FixtureCompetitionTrckGrpLayoutQueryVariables
>;
export const FixtureCompetitionTrckGrpLayout = () => {
  const { fixture, competition, trckGrp, trck } =
    useTypedParams<LayoutParams>();

  const { data } = useQuery(FIXTURE_COMPETITION_TRCKGRP_LAYOUT_QUERY, {
    variables: { competition, trckGrp },
    skip: !!trck,
  });

  const { so5League } = data?.so5 || {};
  const { so5LeagueTrackGroup } = so5League || {};

  if (!trck) {
    return (
      <Navigate
        replace
        to={generatePath(
          FOOTBALL_PLAY_PRO_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK,
          {
            fixture,
            competition,
            trckGrp,
            trck: so5LeagueTrackGroup?.so5LeagueTracks.at(0)?.slug || '',
          }
        )}
      />
    );
  }

  return (
    <>
      <NewPageHeader
        text={navLabels.competitions}
        backTo={generatePath(FOOTBALL_PLAY_PRO_FIXTURE, {
          fixture,
        })}
      />
      <Outlet />
    </>
  );
};

export default FixtureCompetitionTrckGrpLayout;
